import { InjectionToken, Provider } from '@angular/core';

export type DeviceAnalyticsEventsConfig = {
	includeDiscoveryEventsAnalytics: boolean;
};

export const DEVICE_ANALYTIC_EVENTS_CONFIG_DEFAULTS: DeviceAnalyticsEventsConfig = {
	includeDiscoveryEventsAnalytics: false
};

export const DEVICE_ANALYTICS_EVENTS_CONFIG = new InjectionToken<DeviceAnalyticsEventsConfig>(
	'DEVICE_ANALYTICS_EVENTS_CONFIG',
	{
		providedIn: 'root',
		factory: (): DeviceAnalyticsEventsConfig => DEVICE_ANALYTIC_EVENTS_CONFIG_DEFAULTS
	}
);

export function provideDeviceAnalyticsEventsConfig(config: DeviceAnalyticsEventsConfig): Provider {
	return {
		provide: DEVICE_ANALYTICS_EVENTS_CONFIG,
		useValue: { ...DEVICE_ANALYTIC_EVENTS_CONFIG_DEFAULTS, ...config }
	};
}
